import Axios from "axios";
import {
    SET_EMPLOYEE_LOAN_LIST,
    UNSET_EMPLOYEE_LOAN_LIST,
} from "@/store/mutation-types";

import {
    getEmployeeLoanList as getEmployeeLoanListApi,
    getEmployeeLoanById as getEmployeeLoanByIdApi,
    storeEmployeeLoan as storeEmployeeLoanApi,
} from "@/store/api";

const state = {
    employeeLoanList: [],
};

const getters = {
    getEmployeeLoanList(state) {
        return state.employeeLoanList;
    },
};

const mutations = {
    [SET_EMPLOYEE_LOAN_LIST](state, data) {
        state.employeeLoanList = data || [];
    },
    [UNSET_EMPLOYEE_LOAN_LIST](state) {
        state.employeeLoanList = [];
    },
};

const actions = {
    getEmployeeLoanList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
            Axios.get(getEmployeeLoanListApi, { params })
                .then((response) => {
                    commit(SET_EMPLOYEE_LOAN_LIST, response.data?.data || []);
                    resolve(response);
                })
                .catch((error) => {
                    commit(UNSET_EMPLOYEE_LOAN_LIST);
                    reject(error);
                });
        });
    },

    getEmployeeLoanById({ commit }, id) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.get(`${getEmployeeLoanByIdApi}/${id}`)
                .then((response) => {
                    resolve(response.data?.data);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    storeEmployeeLoan({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.post(storeEmployeeLoanApi, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },

    updateEmployeeLoan({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });
        return new Promise((resolve, reject) => {
            Axios.put(`${storeEmployeeLoanApi}/${id}`, data)
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    commit("UNSET_LOADING");
                });
        });
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};
